// These types are declared here because, services listening to azure event hub is waiting for data in a particular way
// Since these events are created base on azure event hub ownership, it makes sense to keep them close to event tracker
// In future we can think of creating a new module as we did for rule engine definitions

export enum ProductListAnalyticsEvent {
  ProductListOpened = 'product-list-opened',
  ProductListReached = 'product-list-reached',
  ListOpenedSessionEvent = 'product-list-opened-session',
  ListClosedSessionEvent = 'product-list-closed-session',
}

export interface IListSessionEventPayload {
  productListId: string;
  lookBookId?: string;
  ownerInternalId?: number;
  ownerExternalId?: string;
  ownerId?: string;
  internalUserId?: number;
  externalUserId?: string;
  eventOccurredDateTime: string;
}
export interface IListOpenedSessionEvent {
  name: ProductListAnalyticsEvent.ListOpenedSessionEvent;
  properties: IListSessionEventPayload;
}

export interface IListClosedSessionEvent {
  name: ProductListAnalyticsEvent.ListClosedSessionEvent;
  properties: IListSessionEventPayload;
}

export interface IProductListOpenedEvent {
  name: ProductListAnalyticsEvent.ProductListOpened;
  properties: {
    userId: string;
    accountId: string;
    ownerId: string;
    externalOwnerId: string;
    source: string;
    productListId: string;
    [key: string]: unknown;
  };
}

export type IProductListAnalyticsEvent =
  | IListOpenedSessionEvent
  | IListClosedSessionEvent
  | IProductListOpenedEvent;
